// Environment configuration
const ENV = process.env.REACT_APP_ENV || 'development';

const config = {
  staging: {
    baseURL: 'https://staging.mtro.co',
    apiURL: 'https://staging.mtro.co/ext/api'
  },
  production: {
    baseURL: 'https://api.metroleads.com',
    apiURL: 'https://api.metroleads.com'
  },
  development: {
    baseURL: 'http://m.com',
    apiURL: 'http://m.com/ext/api'
  }
};

export const API_BASE_URL = config[ENV].baseURL;
export const API_URL = config[ENV].apiURL;
export const ENVIRONMENT = ENV;

export default config[ENV];
